import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useClipboard } from "use-clipboard-copy";
import { TextInputField } from "./TextInputField";
import styles from "./CopyableTextInputField.scss";
import { defineMessage, useIntl } from "react-intl";
import { Button } from "@fluentui/react-components";
import { Copy20Filled } from "@fluentui/react-icons";
import notificationsCenter from "../../singleton/NotificationsCenter";

const copyLabelMessage = defineMessage({
  id: "copyable-text-input-field.copy-label",
  defaultMessage: "Copy"
});

const copiedLabelMessage = defineMessage({
  id: "copyable-text-input-field.copied-label",
  defaultMessage: "Copied to clipboard"
});

export function CopyableTextInputField({ buttonPreset, ...rest }) {
  const intl = useIntl();

  const clipboard = useClipboard({
    copiedTimeout: 600
  });

  const copiedLabel = intl.formatMessage(copiedLabelMessage);

  const handleCopy = useCallback(() => {
    clipboard.copy();
    notificationsCenter.success(copiedLabel);
  }, [clipboard, copiedLabel]);

  const copyLabel = intl.formatMessage(copyLabelMessage);

  // Use a dynamic width based on the content to account for i18n
  const maxLabelLength = Math.max(copyLabel.length, copiedLabel.length);

  return (
    <TextInputField
      ref={clipboard.target}
      afterInput={
        clipboard.isSupported() ? (
          <Button appearance="transparent" onClick={handleCopy} className={styles.copyButton} icon={<Copy20Filled />} />
        ) : undefined
      }
      {...rest}
    />
  );
}

CopyableTextInputField.propTypes = {
  buttonPreset: PropTypes.string
};
